import React, { useState } from 'react';

interface InfoTooltipProps {
    text: string;
}

const InfoTooltip = ({ text }: InfoTooltipProps) => {
    const [show, setShow] = useState(false);
    return (
        <span className="relative inline-flex items-center ml-1" style={{ verticalAlign: 'middle' }}>
            <span
                onMouseEnter={() => setShow(true)}
                onMouseLeave={() => setShow(false)}
                style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '16px',
                    height: '16px',
                    borderRadius: '50%',
                    background: '#6b7280',
                    color: '#fff',
                    fontSize: '11px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    userSelect: 'none',
                    flexShrink: 0
                }}>
                i
            </span>
            {show && (
                <span
                    style={{
                        position: 'absolute',
                        bottom: '120%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: '#1f2937',
                        color: '#fff',
                        borderRadius: '6px',
                        padding: '8px 12px',
                        fontSize: '12px',
                        lineHeight: '1.5',
                        whiteSpace: 'pre-line',
                        width: '260px',
                        zIndex: 9999,
                        boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
                        pointerEvents: 'none'
                    }}>
                    <span dangerouslySetInnerHTML={{ __html: text }} />
                    {/* Arrow */}
                    <span
                        style={{
                            position: 'absolute',
                            top: '100%',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            borderWidth: '5px',
                            borderStyle: 'solid',
                            borderColor: '#1f2937 transparent transparent transparent'
                        }}
                    />
                </span>
            )}
        </span>
    );
};

export default InfoTooltip;